<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group label="หมวดหมู่ระดับที่ 1" class="text-left">
          <b-form-select @change="changeCategory($event, 1)">
            <b-form-select-option
              v-for="(category, categoryIndex) in category1"
              :key="categoryIndex"
              :value="category.categoryId"
              >{{ category.categoryName }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="หมวดหมู่ระดับที่ 2" class="text-left">
          <b-form-select @change="changeCategory($event, 2)">
            <b-form-select-option
              v-for="(category, categoryIndex) in category2"
              :key="categoryIndex"
              :value="category.categoryId"
              >{{ category.categoryName }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="หมวดหมู่ระดับที่ 3" class="text-left">
          <b-form-select @change="changeCategory($event, 3)">
            <b-form-select-option
              v-for="(category, categoryIndex) in category3"
              :key="categoryIndex"
              :value="category.categoryId"
              >{{ category.categoryName }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="หมวดหมู่ระดับที่ 4" class="text-left">
          <b-form-select @change="changeCategory($event, 4)">
            <b-form-select-option
              v-for="(category, categoryIndex) in category4"
              :key="categoryIndex"
              :value="category.categoryId"
              >{{ category.categoryName }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group>
      <b-form-input
        v-model="filter.search"
        @keydown="handleSearch"
        placeholder="Search product name"
      >
      </b-form-input>
    </b-form-group>
    <b-table
      class="table-list"
      striped
      responsive
      hover
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(id)="data">
        <b-form-checkbox
          :checked="selectedProducts.some((item) => item == data.item.id)"
          @change="selectProduct($event, data.item.id)"
        >
        </b-form-checkbox>
      </template>
      <template v-slot:cell(productImage)="data">
        <img :src="data.item.imageUrl" :alt="data.item.name" width="100px" />
      </template>
      <template v-slot:cell(nameAndSku)="data">
        <div>{{ data.item.name }}</div>
        <div>{{ data.item.sku }}</div>
      </template>
    </b-table>
    <b-pagination
      v-model="filter.pageNo"
      :total-rows="total"
      :per-page="filter.perPage"
      class="m-md-0"
      @change="changePage"
      align="center"
    ></b-pagination>
    <div class="text-right">
      <b-button @click="confirm" variant="primary">ตกลง</b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedProducts: [],
      category1: [],
      category2: [],
      category3: [],
      category4: [],
      filter: {
        search: "",
        pageNo: 1,
        perPage: 5,
        productIdList: [],
        Categories: [],
      },
      isBusy: false,
      items: null,
      total: 0,
      fields: [
        {
          key: "id",
          label: "",
        },
        {
          key: "productImage",
          label: "รูปภาพ",
          class: "w-100px",
        },
        {
          key: "nameAndSku",
          label: "ชื่อสินค้า (SKU)",
          class: "w-100px",
        },
        {
          key: "barcode",
          label: "บาร์โค้ด",
          class: "w-100px",
        },
        {
          key: "price",
          label: "ราคา",
          class: "w-100px",
        },
      ],
    };
  },
  created() {
    this.selectedProducts = [...this.products.map((item) => item.productId)];
    this.getList();
    this.getCategories(0, 1);
  },
  props: {
    products: {
      required: true,
      type: Array,
    },
    confirmProduct: {
      required: true,
      type: Function,
    },
  },
  methods: {
    confirm() {
      this.confirmProduct(this.products, this.selectedProducts);
    },
    changeCategory(event, categoryNumer) {
      switch (categoryNumer) {
        case 1:
          this.category2 = [];
          this.category3 = [];
          this.category4 = [];
          this.getCategories(event, 2);
          this.filter.Categories = [event];
          break;
        case 2:
          this.category3 = [];
          this.category4 = [];
          this.getCategories(event, 3);
          this.filter.Categories = [
            ...this.filter.Categories.slice(0, 1),
            event,
          ];
          break;
        case 3:
          this.category4 = [];
          this.getCategories(event, 4);
          this.filter.Categories = [
            ...this.filter.Categories.slice(0, 2),
            event,
          ];
        case 4:
          this.filter.Categories = [
            ...this.filter.Categories.slice(0, 3),
            event,
          ];
          break;
      }
      console.log("filter", this.filter.Categories);
      this.getList();
    },
    selectProduct(event, productId) {
      if (event) {
        this.selectedProducts.push(productId);
      } else {
        this.selectedProducts.splice(
          this.selectedProducts.findIndex((item) => item == productId),
          1
        );
      }
    },
    changePage(Page) {
      this.filter.pageNo = Page;
      this.getList();
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
      }
    },
    select(product) {
      this.selectProduct(this.products, product);
    },
    getList: async function() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/product/list`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.dataList;
            this.total = data.detail.count;
            this.isBusy = false;
          }
          console.log("item", this.items);
        });
    },
    getCategories: async function(categoryId, catetoryNumber) {
      await this.axios
        .get(`${this.$baseUrl}/product/category/${categoryId}`)
        .then((data) => {
          console.log("get category", data);
          if (data.result == 1) {
            switch (catetoryNumber) {
              case 1:
                this.category1 = data.detail.category;
                break;
              case 2:
                this.category2 = data.detail.category;
                break;
              case 3:
                this.category3 = data.detail.category;
                break;
              case 4:
                this.category4 = data.detail.category;
                break;
            }
          }
        });
    },
  },
};
</script>

<style></style>
